/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Benefits_Choose_Plan_To_ContinueInputs */

const en_mobile_benefits_choose_plan_to_continue = /** @type {(inputs: Mobile_Benefits_Choose_Plan_To_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a plan to continue using Listening.`)
};

const es_mobile_benefits_choose_plan_to_continue = /** @type {(inputs: Mobile_Benefits_Choose_Plan_To_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige un plan para seguir usando Listening.`)
};

/**
* | output |
* | --- |
* | "Choose a plan to continue using Listening." |
*
* @param {Mobile_Benefits_Choose_Plan_To_ContinueInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_benefits_choose_plan_to_continue = /** @type {((inputs?: Mobile_Benefits_Choose_Plan_To_ContinueInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Benefits_Choose_Plan_To_ContinueInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_benefits_choose_plan_to_continue(inputs)
	return en_mobile_benefits_choose_plan_to_continue(inputs)
});